import { combineReducers } from 'redux'
import { fetchBootstrapAsync } from 'shared/store/actions/bootstrap'
import {
  patchNotificationSettingsAction,
  trafficControllPatchNotificationSettingsAction,
} from 'shared/store/actions/notifications'
import {
  NotificationPayload,
  NotificationPlatform,
  NotificationSound,
  NotificationValue,
} from 'shared/typings/notificationSettings/NotificationPayload'

import { AnyRootAction, createReducer } from 'typesafe-actions'

const notificationSettings = createReducer<NotificationPayload, AnyRootAction>({
  email: NotificationValue.MINE,
  sound: NotificationSound.DING,
  ABM: true,
})
  .handleAction([fetchBootstrapAsync.success], (_, action) => {
    const properties = action.payload.currentUser.properties

    return {
      email: properties[NotificationPlatform.EMAIL_NOTIFICATION] as NotificationValue,
      sound: properties[NotificationPlatform.SOUND_SETTING] as NotificationSound,
      ABM: properties[NotificationPlatform.ABM] ?? true,
    }
  })
  .handleAction(
    [patchNotificationSettingsAction, trafficControllPatchNotificationSettingsAction],
    (_, action) => {
      return action.payload
    }
  )

export default combineReducers({
  notificationSettings: notificationSettings,
})
